export const COEFFICIENTS = {
  age: -0.0471,
  sex: 0.1387,
  eGFR: -0.1224,
  hemo: -0.0171,
  albuminuriaMild: 0.8535,
  albuminuriaHEavy: 1.7352,
  priorInv: 0.2217
};

export const BASELINES = {
  age: -73.62,
  eGFR: -51.12,
  hemo: -130.95
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.47
};
